import { useAccountState } from '../../redux/reducers/accountReducer';
import { useActiveBillableTimerActions } from "../../redux/actions/activeBillableTimerActions";
import { useActiveBillableTimerState } from "../../redux/reducers/activeBillableTimerReducer";
import { TimeTrackingEntry, UserAccount } from "../types";
import { useApi } from "../api/useApi";


export const ActiveTimeEntryApiRoutes = {
    getActiveTimeEntry: (accountId: string, userId: string) => `account/${accountId}/user/${userId}/activeTimeEntry`,
}

export const useActiveTimeEntryService = () => {

    //Hooks
    const { primaryAccount } = useAccountState();
    const { account, user } = primaryAccount as UserAccount ?? {};
    const { activeTimeEntry } = useActiveBillableTimerState();
    const { setActiveTimer, clearActiveTimer } = useActiveBillableTimerActions();

    const api = useApi<TimeTrackingEntry>(`api/TimeTracking`);

    const loadActiveTimeEntry = async () => {
        if (!!account) {
            try {
                const entry = await api.getAsync(ActiveTimeEntryApiRoutes.getActiveTimeEntry(account.accountId as string, user.userId as string));
                if (!!entry?.entryId) {
                    setActiveTimer(entry);
                } else {
                    // The persisted timer is stale if the server no longer reports one running.
                    clearActiveTimer();
                }
            } catch (e) {
                //nom nom nom
                //console.log('nom nom nom');
            }
        }
    }

    return {
        loadActiveTimeEntry,
        activeTimeEntry,
        setActiveTimeEntry: setActiveTimer,
        clearActiveTimeEntry: clearActiveTimer,
    }
}